import React from 'react';

import LinkButton from '../LinkButton';

export const SignInLink = React.forwardRef((props, ref) => {
  SignInLink.displayName = 'SignInLink';

  return (
    <LinkButton
      ref={ref}
      isHollow={false}
      href="/signin"
    >
      Sign In
    </LinkButton>
  );
});

export default SignInLink;
